"use client";

import CTABannerSection from "@/components/shared/cta-banner-section";
import FAQSection from "@/components/shared/faq-section";
import ShippingHeroSection from "@/components/shipping/hero-section";
import ShippingMethodsSection from "@/components/shipping/shipping-methods";
import PackagingSection from "@/components/shipping/packaging-section";
import DeliveryCoverageSection from "@/components/shipping/delivery-coverage-section";

export default function ShippingPageView() {
  return (
    <main>
      <ShippingHeroSection />
      <ShippingMethodsSection />
      <PackagingSection />
      <DeliveryCoverageSection />
      <FAQSection />
      <CTABannerSection />
    </main>
  );
}
